import {Directive, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[appOnlyNumber]'
})
export class OnlyNumberDirective {
  regexStr = '^[0-9]+$';

  @Input() appOnlyNumber: boolean | undefined;

  constructor() {
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (!this.appOnlyNumber) {
      return;
    }

    const allowedKeys = [
      'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter', '.',
    ];
    const ctrlCommands = ['a', 'c', 'v', 'x'];

    if (
      allowedKeys.includes(event.key) ||
      (ctrlCommands.includes(event.key.toLowerCase()) && (event.ctrlKey || event.metaKey))
    ) {
      return;
    }

    if (event.shiftKey || !/^\d$/.test(event.key)) {
      event.preventDefault();
    }

    const regEx = new RegExp(this.regexStr);
    if (!regEx.test(event.key)) {
      event.preventDefault();
    }
  }
}
